/**
 * This function searches for a chapter by its ID within a nested array of chapters.
 * It recursively traverses through sub-chapters if they exist.
 *
 * @param {Chapter[]} chapters - The array of chapters to search within.
 * @param {string} id - The ID of the chapter to find.
 * @returns {Chapter | null} - The chapter with the matching ID, or null if not found.
 *
 * Usage:
 * const chapter = findChapterById(chapters, 'chapterId');
 * if (chapter) {
 *   console.log('Chapter found:', chapter);
 * } else {
 *   console.log('Chapter not found');
 * }
 */
import { Chapter } from "graphql/types"

export const findChapterById = (
  chapters: Chapter[],
  id: string
): Chapter | null => {
  for (const chapter of chapters) {
    if (chapter.id === id) {
      return chapter
    }
    if (chapter.subChapter && chapter.subChapter.length > 0) {
      const found = findChapterById(chapter.subChapter, id)
      if (found) {
        return found
      }
    }
  }
  return null
}
